import type { QuizAnswers } from "../types"

/**
 * Whole years from a stored "YYYY-MM-DD" date of birth, for the GA `age` param.
 * Returns undefined for an unset/partial/implausible date so the param is simply
 * omitted rather than sent as a wrong number.
 */
export function ageFromDob(answers: QuizAnswers, key = "dob"): number | undefined {
  const value = answers[key]
  if (typeof value !== "string") return undefined
  const [year, month, day] = value.split("-").map(Number)
  if (!year || !month || !day) return undefined
  const today = new Date()
  let age = today.getFullYear() - year
  const hadBirthdayThisYear =
    today.getMonth() + 1 > month ||
    (today.getMonth() + 1 === month && today.getDate() >= day)
  if (!hadBirthdayThisYear) age -= 1
  return age >= 0 && age < 130 ? age : undefined
}
